/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FetchData } from 'app/shared/generalMethods';
import { AdminCommunityService } from 'app/services/admin-community.service';

@Component({
  selector: 'app-create-community',
  templateUrl: './create-community.component.html',
  styleUrls: ['./create-community.component.scss']
})
export class CreateCommunityComponent {

  @Output() cancel = new EventEmitter<void>();
  @Output() submitForm = new EventEmitter<any>();

  isEditMode = false;
  pageLoader = false;
  pageLoaderText = 'Loading...';
  communityForm: FormGroup;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private _router: Router,
    private _snackBar: MatSnackBar,
    private _fetchData: FetchData,
    private adminCommunityService: AdminCommunityService,
  ) {
    this.communityForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(50)]],
      description: ['', [Validators.maxLength(200)]],
      location: ['', Validators.required],
      contactEmail: ['', Validators.email],
      contactPhone: [''],
      isPublic: [true]
    });
  }

  get name() {
    return this.communityForm.get('name');
  }

  get description() {
    return this.communityForm.get('description');
  }

  get location() {
    return this.communityForm.get('location');
  }

  get contactEmail() {
    return this.communityForm.get('contactEmail');
  }

  get contactPhone() {
    return this.communityForm.get('contactPhone');
  }

  onCancel() {
    this.cancel.emit();
  }


onSubmit() {

  const { countAdmin, countStaff } = this._fetchData.data;

  if (this.communityForm.valid) {
    this.isLoading = true;

    const adminId = localStorage.getItem('adminId');
    const staffId = this._fetchData.data?.lstStaffData[0]?.Id;

    this.pageLoader = true;
    this.pageLoaderText = 'Creating Community...';

    // If admin is logged in
    if (countAdmin === 1) {
      this.adminCommunityService.createCommunity(this.communityForm.value, adminId).subscribe(
        (response) => {
          this.handleCommunityResponse(response, 'admin');
        },
        (error) => {
          this.pageLoader = false;
          this._snackBar.open('Error creating community as admin!', 'Close', {
            duration: 3000
          });
        }
      );
    }
    // If staff is logged in (and not admin)
    else if (countStaff === 1) {
      this.adminCommunityService
  .createCommunityWithStaff(this.communityForm.value, staffId, adminId)
  .subscribe(
    (response) => {
      this.handleCommunityResponse(response, 'staff');
    },
    (error) => {
      this.pageLoader = false;
      this._snackBar.open('Error creating community as staff!', 'Close', {
        duration: 3000
      });
    }
  );
    }
    // Fallback case: neither admin nor staff
    else {
      this.pageLoader = false;
      this._snackBar.open('No valid user (admin/staff) found to create community.', 'Close', {
        duration: 3000
      });
    }
  }
}

// Helper to handle responses
handleCommunityResponse(response: any, userType: 'admin' | 'staff') {
  if (response && response.success) {
    this._fetchData.setLocalStorage(response.msg);
    this._snackBar.open(
      `Community created successfully as ${userType}!`,
      'Close',
      { duration: 3000 }
    );

    this.isEditMode = false;
    this.pageLoader = false;

    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._router.navigate(['/community-list']);
    });
  } else {
    this.pageLoader = false;
    this._snackBar.open(`Failed to create community as ${userType}!`, 'Close', {
      duration: 3000
    });
  }
}


}
